export default {
  id: 22,
  title: 'Target #22 - Cloud',
  url: 'https://cssbattle.dev/play/22',
  colors: ['#F5D6B4', '#D86F45'],
  solution:
    '<a a><a b><style>body{background:#f5d6b4}a{position:fixed;background:#d86f45}a[a]{width:100;height:100;border-radius:50%;top:115;left:100;box-shadow:80px -30px #d86f45}a[b]{width:150;height:50;border-radius:0 25px 25px 0;top:165;right:100}</style>',
}
